/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Subject = () => {
  // State variables
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [ID, setID] = useState(null);
  const [modules, setModules] = useState([]);
  const [filterModule, setFilterModule] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Add Subject");
  const [userPermissions, setUserPermissions] = useState({});

  useEffect(() => {
    auth();
    fetchModules();
    fetchData();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 3);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getAllDetails");

      const response = await api.post("module/moduleCurl", fd);
      if (Array.isArray(response.data.getResponse)) {
        setModules(response.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchData(page = 1, moduleId = filterModule, search = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSubjectDetails");
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      if (moduleId) {
        fd.append("moduleId", moduleId);
      }

      if (search.trim() !== "") {
        fd.append("searchTerm", search.trim());
      }

      const response = await api.post("subject/subjectCurl", fd);

      if (response.data && Array.isArray(response.data.getSubjectDetails)) {
        setFetchedData(response.data.getSubjectDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch {
      setFetchedData([]);
      setTotalItems(0);
    } finally {
      setDataLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    if (!selectedModule) {
      toast.error("Please select Class");
      setLoading(false);
      return;
    }

    if (!subjectName.trim()) {
      toast.error("Please enter subject name");
      setLoading(false);
      return;
    }

    setButtonText(ID ? "Updating..." : "Adding...");

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updateSubject" : "addSubject";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("subjectName", subjectName.trim());
    fd.append("module", selectedModule);

    if (ID) {
      fd.append("id", ID);
    }

    try {
      const response = await api.post("subject/subjectCurl", fd);

      if (response.data.status === true) {
        toast.success(response.data.data || "Operation successful");
        fetchData(currentPage, filterModule, searchTerm);
        handleClose();
      } else {
        toast.error(response.data.data || "Operation failed");
      }
    } catch (error) {
      toast.error("There was an error submitting the form. Please try again.");
    } finally {
      setLoading(false);
      setButtonText("Add Subject");
    }
  }

  const handleShowAdd = () => {
    setShow(true);
    setID(null);
    setSubjectName("");
    setButtonText("Add Subject");
    setSelectedModule("");
  };

  async function handleShowEdit(subject) {
    setButtonText("Update Subject");
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", subject.id);

    try {
      const response = await api.post("subject/subjectCurl", fd);

      if (response.data && response.data.getSubjectDetails) {
        const subjectDetails = response.data.getSubjectDetails[0];
        setSubjectName(subjectDetails.subjectName);
        setSelectedModule(subjectDetails.moduleId);
        setID(subjectDetails.id);
        setShow(true);
      }
    } catch (error) {
      toast.error("Error fetching subject details");
    }
  }

  const handleClose = () => {
    setShow(false);
    setSubjectName("");
    setSelectedModule("");
    setID(null);
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this subject?")) return;

    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteSubject";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("subject/subjectCurl", fd);
      toast.success("Subject deleted successfully");
      fetchData(currentPage, filterModule, searchTerm);
    } catch (error) {
      toast.error("Error deleting subject.");
    } finally {
      setLoading(false);
    }
  }

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page, filterModule, searchTerm);
    }
  };

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  const TableLoader = ({ rows = 10, columns = 5 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search subjects..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "280px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, filterModule, searchTerm)}
                  />
                </div>

                {/* Filter by Class */}
                <div style={{ minWidth: "180px" }}>
                  <select
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "100%",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      color: "#334155",
                      cursor: "pointer"
                    }}
                    value={filterModule}
                    onChange={(e) => {
                      const moduleId = e.target.value;
                      setFilterModule(moduleId);
                      setCurrentPage(1);
                      fetchData(1, moduleId, searchTerm);
                    }}
                  >
                    <option value="">All Classes</option>
                    {modules.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.moduleName}
                      </option>
                    ))}
                  </select>
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add New Subject
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Subjects Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "600px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "48px",
                        minWidth: "48px",
                        maxWidth: "48px",
                        padding: "14px 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Subject Name
                    </th>
                  
                    {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "#475569",
                          textTransform: "uppercase",
                          letterSpacing: "0.4px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>

                {dataLoading ? (
                  <TableLoader rows={6} columns={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 4 : 3} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 4 : 3} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              📚
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No subjects found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm || filterModule
                                ? "Try adjusting your filters or search"
                                : "Create your first subject"}
                            </div>
                            {!searchTerm && !filterModule && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleShowAdd}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Create First Subject
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((subject, index) => (
                        <tr key={subject.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s"
                        }}>
                          <td
                            style={{
                              width: "48px",
                              minWidth: "48px",
                              maxWidth: "48px",
                              padding: "6px",
                              fontSize: "12px",
                              color: "#64748b",
                              fontWeight: "500",
                              textAlign: "center",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#475569",
                                margin: "0 auto"
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>
                          </td>
                          
                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap"
                            }}>
                              {subject.subjectName}
                            </div>
                          </td>
                          
                         
                          
                          {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                            <td style={{ padding: "12px", textAlign: "center" }}>
                              <div style={{
                                display: "flex",
                                gap: "6px",
                                justifyContent: "center",
                                flexWrap: "wrap"
                              }}>
                                {userPermissions.is_edit === "1" && (
                                  <button
                                    onClick={() => handleShowEdit(subject)}
                                    title="Edit Subject"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#eff6ff",
                                      color: "#3b82f6",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#dbeafe"}
                                    onMouseLeave={(e) => e.target.style.background = "#eff6ff"}
                                  >
                                    <PencilSimpleLine size={14} />
                                  </button>
                                )}

                                {userPermissions.is_delete === "1" && (
                                  <button
                                    onClick={() => handleDelete(subject.id)}
                                    title="Delete Subject"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#fef2f2",
                                      color: "#dc2626",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#fee2e2"}
                                    onMouseLeave={(e) => e.target.style.background = "#fef2f2"}
                                  >
                                    <Trash size={14} />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Compact Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />

      {/* Modal for adding/editing subject */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "14px 24px",
          background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
          color: "#fff"
        }}>
          <div>
            <Modal.Title style={{ fontSize: "20px", fontWeight: "700", marginBottom: "4px" , color:"#fff"}}>
              {ID ? "✏️ Edit Subject" : "➕ Add Subject"}
            </Modal.Title>
            
          </div>
        </Modal.Header>
        <Modal.Body style={{
          padding: "28px",
          background: "#f8fafc"
        }}>
          <form onSubmit={handleSubmit} id="add-subject-form">
            {/* Select Class */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Select Class <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155",
                  cursor: "pointer"
                }}
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
                required
              >
                <option value="">Select Class</option>
                {modules.map((mod) => (
                  <option key={mod.id} value={mod.id}>
                    {mod.moduleName}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Subject Name <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155"
                }}
                placeholder="Enter subject name"
                id="subjectName"
                name="subjectName"
                value={subjectName}
                onChange={(e) => setSubjectName(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer style={{
          borderTop: "1px solid #e5e7eb",
          padding: "24px 28px",
          background: "#f8fafc"
        }}>
          <Button 
            variant="secondary" 
            onClick={handleClose}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {buttonText}
              </>
            ) : (
              buttonText
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          select:hover, input:hover {
            border-color: #94a3b8 !important;
          }
          
          select:focus, input:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default Subject;